import React from 'react';
import Style from './Gdpr.module.css';

const Gdpr = () => {
  return (
    <>
      <div className='Navbar__Height'></div>
      <div className={Style.Protection__Page__Wrapper}>
        <div className={Style.Header__Section}>
          <div className='container'>
            <h1 className={Style.Page__Title}>General Data Protection Regulation (GDPR)</h1>
          </div>
        </div>
        <div className={Style.Page__Content}>
          <div className='container'>
            
            <h4>Our Commitment</h4>
            <p>
              The General Data Protection Regulation (GDPR) is a European Union
              regulation designed to protect the personal data of individuals
              located in the EU/EEA. Fyntiq LLC is committed to compliance with
              GDPR and to safeguarding the privacy of all users who interact
              with our services.
            </p>

            <h4>Your Rights Under GDPR</h4>
            <p>
              As an EU/EEA resident, you have the following rights regarding
              your personal data:
            </p>
            <ul>
              <li>The right to be informed about how your data is collected and used.</li>
              <li>The right of access to the personal data we hold about you.</li>
              <li>The right to rectification of inaccurate or incomplete data.</li>
              <li>The right to erasure (“right to be forgotten”).</li>
              <li>The right to restrict processing of your personal data.</li>
              <li>The right to data portability so you can take your data elsewhere.</li>
              <li>The right to object to processing, including for direct marketing purposes.</li>
              <li>The right not to be subject to automated decision-making without meaningful human input.</li>
            </ul>

            <h4>How Fyntiq LLC Complies</h4>
            <p>
              Our internal policies have long been aligned with the objectives
              of GDPR. For example:
            </p>
            <ul>
              <li>We provide clear Terms of Use and Privacy Policy to explain how your data is handled.</li>
              <li>You may close your account and request deletion of your personal data.</li>
              <li>You can request a copy of your data at any time.</li>
              <li>You may opt out of marketing communications at any time.</li>
              <li>We maintain strict technical and organizational measures to protect personal data.</li>
            </ul>

            <h4>International Data Transfers</h4>
            <p>
              Fyntiq LLC is headquartered in Delaware, United States. If you are
              located in the EU/EEA, your personal data may be transferred
              outside of Europe. We use appropriate safeguards, such as Standard
              Contractual Clauses (SCCs), to ensure your rights are protected in
              accordance with GDPR.
            </p>

            <h4>Contacting Us</h4>
            <p>
              If you have any questions about GDPR compliance or wish to
              exercise your rights, please contact our Privacy Officer:
            </p>
            <ul>
              <li>Fyntiq LLC</li>
              <li>16192 Coastal Highway</li>
              <li>Lewes, Delaware 19958</li>
              <li>Email: <a href="mailto:privacy@fyntiq.com">privacy@fyntiq.com</a></li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Gdpr;